import { renderHeader } from "./main";

// The <eyevinn-video> player is only used on this page. Load it as its own
// chunk so the other pages, which import main.ts purely for the navbar, do
// not download ~1.9 MB of player they never instantiate. The two
// <eyevinn-video> elements upgrade automatically once the element registers.
//
// The catch matters because the chunk can now fail independently of the page:
// deploys sync with --delete behind CloudFront, so a cached index.html can
// outlive the hash-named chunk it points at. Without this the failure is an
// unhandled rejection and the video slots render as nothing, with no clue why.
import("@eyevinn/web-player-component").catch((err) => {
  console.error("Failed to load the <eyevinn-video> player chunk", err);
});

document.addEventListener("DOMContentLoaded", function () {
  renderHeader("STSWE26");

  // Speaker card expand/modal
  const speakerCards = document.querySelectorAll(".speaker-card.clickable");
  const sessionDetails = document.getElementById("session-details");
  const mobilePopup = document.getElementById("mobile-popup");
  const popupContent = document.getElementById("popup-content");
  const closePopup = document.getElementById("close-popup");
  let activeSession = null;
  // Focus management: remember which card opened the panel/popup so we can return focus on close
  let lastTriggerCard = null;

  // Make the desktop session-details panel keyboard-focusable + accessible
  if (sessionDetails) {
    sessionDetails.setAttribute("role", "region");
    sessionDetails.setAttribute("aria-label", "Session details");
    sessionDetails.setAttribute("tabindex", "-1");
  }

  const isMobile = () => window.innerWidth < 768;

  function clearActiveCard() {
    document.querySelectorAll(".speaker-card.active").forEach(function (c) {
      c.classList.remove("active");
    });
  }

  function returnFocusToTrigger() {
    if (lastTriggerCard && typeof lastTriggerCard.focus === "function") {
      lastTriggerCard.focus();
    }
    lastTriggerCard = null;
  }

  function showSession(card) {
    const sessionId = card.getAttribute("data-session");
    const contentElement = document.getElementById(sessionId + "-data");
    if (!contentElement) return;

    lastTriggerCard = card;

    if (isMobile()) {
      sessionDetails.style.display = "none";
      clearActiveCard();
      popupContent.innerHTML = contentElement.innerHTML;
      mobilePopup.style.display = "flex";
      document.body.style.overflow = "hidden";
      // Move focus into the dialog so keyboard + screen-reader users land there
      if (closePopup && typeof closePopup.focus === "function") {
        closePopup.focus();
      }
    } else {
      if (activeSession === sessionId && !sessionDetails.classList.contains("hidden")) {
        sessionDetails.classList.add("hidden");
        sessionDetails.style.display = "none";
        activeSession = null;
        clearActiveCard();
        returnFocusToTrigger();
      } else {
        clearActiveCard();
        card.classList.add("active");
        sessionDetails.style.display = "block";
        sessionDetails.classList.remove("hidden");
        sessionDetails.innerHTML = contentElement.innerHTML;
        activeSession = sessionId;
        sessionDetails.scrollIntoView({ behavior: "smooth", block: "nearest" });
        // Move focus into the region so keyboard users follow the visual jump
        sessionDetails.focus();
      }
    }
  }

  speakerCards.forEach(function (card) {
    card.addEventListener("click", function () {
      showSession(this);
    });
    card.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        showSession(this);
      }
    });
  });

  function hidePopup() {
    mobilePopup.style.display = "none";
    document.body.style.overflow = "";
    returnFocusToTrigger();
  }

  closePopup.addEventListener("click", hidePopup);
  mobilePopup.addEventListener("click", function (e) {
    if (e.target === mobilePopup) hidePopup();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    // Mobile: close popup
    if (mobilePopup.style.display === "flex") {
      hidePopup();
      return;
    }
    // Desktop: collapse the session-details region and return focus to the triggering card
    if (!isMobile() && activeSession && sessionDetails && !sessionDetails.classList.contains("hidden")) {
      sessionDetails.classList.add("hidden");
      sessionDetails.style.display = "none";
      activeSession = null;
      clearActiveCard();
      returnFocusToTrigger();
    }
  });

  window.addEventListener("resize", function () {
    if (isMobile()) {
      sessionDetails.style.display = "none";
      if (mobilePopup.style.display === "flex") {
        mobilePopup.style.display = "none";
        document.body.style.overflow = "";
      }
    } else {
      sessionDetails.style.display = activeSession ? "block" : "none";
    }
  });
});
